import { loadDynamicScript } from "./Util";
export class RecaptchaManager {
    init(loadScript = true, userIsAuthenticated = false) {
        if (!userIsAuthenticated) {
            $(".g-recaptcha").each((idx, elem) => {
                const $captchaWrapper = $(elem);
                $captchaWrapper.append("Loading captcha...");
            });
            if (loadScript) {
                this.LoadScript();
            }
        }
    }
    LoadScript() {
        loadDynamicScript("recaptcha", "https://www.google.com/recaptcha/api.js?onload=grecaptchaOnLoad&render=explicit");
    }
}
global["grecaptchaOnLoad"] = function () {
    try {
        const siteKey = document.getElementById("recaptchaSiteKey").value;
        const captchas = document.getElementsByClassName("g-recaptcha");
        for (let i = 0; i < captchas.length; i++) {
            const element = captchas[i];
            if (!element.getAttribute("data-RecaptchaWidgetId")) {
                const params = { "sitekey": siteKey };
                const recaptchaWidgetId = window.grecaptcha.render(element, params);
                element.setAttribute("data-RecaptchaWidgetId", recaptchaWidgetId.toString());
            }
        }
    }
    catch (e) {
        console.log(e);
    }
};
export const getCaptchaResponse = (recaptchaWidgetId) => {
    if (!window.grecaptcha) {
        return;
    }
    return window.grecaptcha.getResponse(recaptchaWidgetId);
};
export const resetCaptcha = (recaptchaWidgetId) => {
    if (!window.grecaptcha) {
        return;
    }
    try {
        window.grecaptcha.reset(recaptchaWidgetId);
    }
    catch (e) {
    }
};
//# sourceMappingURL=RecaptchaManager.js.map